import CellDate from '@/components/GokuDataGrid/CellDate'
import CellLink from '@/components/GokuDataGrid/CellLink'
import CellStatus from '@/components/GokuDataGrid/CellStatus'
import { formatCurrency } from '@/utils/function'
import { generatePathDatacentral, paths } from '@/utils/path'
import { TFunction } from 'i18next'
import { Typogaphy } from 'vnetwork-ui'
import { GridColDefVNW } from 'vnetwork-ui/dist/components/DataGridPro'
import { Color } from 'vnetwork-ui/dist/types'
import {
    CONTRACT_DIRECTION_OPTIONS,
    CONTRACT_NDA_OPTIONS,
    CONTRACT_RENEW_OPTIONS,
    CONTRACT_ROLE_OPTIONS,
    CONTRACT_SLA_OPTIONS,
    CONTRACT_STATUS,
} from '../../../constants'
import { CustomerContract } from '../../../types'

export const customerContractColumns = (
    t: TFunction
): GridColDefVNW<CustomerContract>[] => [
    {
        field: 'contract_id',
        headerName: t('contract_id'),
        width: 150,
        renderCell: ({ row }) => (
            <CellLink
                to={generatePathDatacentral(paths.customerContractDetail, {
                    id: row?.contract_id,
                })}
            >
                {row?.contract_id}
            </CellLink>
        ),
    },
    {
        field: 'contract_number_id',
        headerName: t('contract_number_id'),
        width: 200,
        renderCell: ({ row }) => (
            <Typogaphy size="small">{row?.contract_number_id}</Typogaphy>
        ),
    },
    {
        field: 'contract_owner',
        headerName: t('contract_owner'),
        width: 200,
        renderCell: ({ row }) => (
            <CellLink
                to={generatePathDatacentral(paths.customerDetail, {
                    id: row?.customer_id,
                })}
            >
                {row?.company_name || row?.customer_name}
            </CellLink>
        ),
    },
    {
        field: 'sla_enable',
        headerName: t('sla_enable'),
        width: 130,
        renderCell: ({ row }) => {
            const status = CONTRACT_SLA_OPTIONS(t)?.find(
                (status) => status?.value === !!row?.sla_enable
            )

            return (
                <CellStatus
                    color={status?.color as Color}
                    label={status?.label}
                />
            )
        },
    },
    {
        field: 'nda_enable',
        headerName: t('nda_enable'),
        width: 130,
        renderCell: ({ row }) => {
            const status = CONTRACT_NDA_OPTIONS(t)?.find(
                (status) => status?.value === !!row?.nda_enable
            )

            return (
                <CellStatus
                    color={status?.color as Color}
                    label={status?.label}
                />
            )
        },
    },
    {
        field: 'auto_renewable',
        headerName: t('auto_renewable'),
        width: 165,
        renderCell: ({ row }) => {
            const status = CONTRACT_RENEW_OPTIONS(t)?.find(
                (status) => status?.value === !!row?.auto_renewable
            )

            return (
                <CellStatus
                    color={status?.color as Color}
                    label={status?.label}
                />
            )
        },
    },
    {
        field: 'contract_status',
        headerName: t('contract_status'),
        width: 200,
        renderCell: ({ row }) => {
            const status = CONTRACT_STATUS(t)?.find(
                (status) => status.value === row?.contract_status
            )
            return (
                <CellStatus
                    label={t(status?.label as string)}
                    color={status?.color as Color}
                />
            )
        },
    },
    {
        field: 'contract_role',
        headerName: t('contract_role'),
        width: 170,
        renderCell: ({ row }) => {
            const role = CONTRACT_ROLE_OPTIONS(t)?.find(
                (status) => status.value === row?.contract_role
            )
            return (
                <CellStatus
                    label={role?.label || row?.contract_role || '---'}
                    color={role?.color as Color}
                />
            )
        },
    },
    {
        field: 'contract_direction',
        headerName: t('contract_direction'),
        width: 170,
        renderCell: ({ row }) => {
            const direction = CONTRACT_DIRECTION_OPTIONS(t)?.find(
                (status) => status.value === row?.contract_direction
            )
            return (
                <CellStatus
                    label={direction?.label || row?.contract_direction || '---'}
                    color={direction?.color as Color}
                />
            )
        },
    },
    {
        field: 'contract_key',
        headerName: t('contract_key'),
        width: 200,
        renderCell: ({ row }) => (
            <div className="w-100 h-100">
                <Typogaphy size="small" className="text-right">
                    {row?.contract_key}
                </Typogaphy>
            </div>
        ),
    },
    {
        field: 'contract_value',
        headerName: t('contract_value'),
        width: 200,
        renderCell: ({ row }) => (
            <div className="flex w-full h-full items-center justify-end">
                <Typogaphy size="small">
                    {formatCurrency(row?.contract_value)}
                </Typogaphy>
            </div>
        ),
    },
    {
        field: 'contract_effective_date',
        headerName: t('contract_effective_date'),
        width: 200,
        renderCell: ({ value }) => <CellDate date={value} />,
    },
    {
        field: 'contract_expiry_date',
        headerName: t('contract_expiry_date'),
        width: 200,
        renderCell: ({ value }) => <CellDate date={value} />,
    },
    {
        field: 'contract_service',
        headerName: t('contract_service'),
        width: 200,
        renderCell: ({ row }) => (
            <CellLink
                to={generatePathDatacentral(paths.serviceDetail, {
                    id: row?.service_id,
                })}
            >
                {row?.service_name}
            </CellLink>
        ),
    },
]
